import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { InspectionPoint, Inspection } from '../../shared/models/index';

@Component({
    selector: 'point-edit',
    templateUrl: './edit.component.html',
    standalone: false
})
export class PointEditComponent implements OnInit {
  @Input() public point: InspectionPoint;
  @Input() public processing;
  @Output() public toggleSavePoint: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  editForm: UntypedFormGroup;
  inspection: Inspection;

  constructor() {}

  ngOnInit(): void {
    this.inspection = this.point.inspection;
    this.initForm();
  }

  public updatePoint(model: any) {
    this.point.name = model.name;
    this.point.description = model.description;
    this.toggleSavePoint.emit(this.point);
  }

  public cancel() {
    this.toggleCancel.emit();
  }

  initForm() {
    const regex = new RegExp(/<br\s*[\/]?>/gi);
    this.editForm = new UntypedFormGroup({
      name: new UntypedFormControl(this.point.name, Validators.required),
      description: new UntypedFormControl(this.point.description.replace(regex, '\n'))
    });
  }
}
